import {useState, useEffect} from 'react';
import _ from 'lodash';

const useHotKey = (callback = () => {}, keys = [], dependencies = []) => {
  // State for keeping track of whether key is pressed
  const [pressedKeysSet, setPressedKeysSet] = useState(new Set());

  function downHandler({key}) {
    if (_.includes(keys, key)) {
      pressedKeysSet.add(key);

      setPressedKeysSet(new Set(pressedKeysSet));
    }

    //HINT if all keyCodes pressed invoke callback
    if (_.isEqual([...pressedKeysSet.values()], keys)) {
      callback();
    }
  }

  const upHandler = ({key}) => {
    if (_.includes(keys, key)) {
      pressedKeysSet.delete(key);

      setPressedKeysSet(new Set(pressedKeysSet));
    }
  };
  // Add event listeners
  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, dependencies);
};

export default useHotKey;
